import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const assetService = {
  /** Asset persistido + URL vigente, resuelto por el backend. */
  async getAsset(assetId) {
    const res = await axios.get(`${API}/assets/${assetId}`);
    return res.data.asset;
  },

  /** Identifica el asset que corresponde a una URL guardada (proyectos viejos). */
  async lookupByUrl(url) {
    const res = await axios.get(`${API}/assets/lookup`, { params: { url } });
    return res.data.asset;
  },
};

export default assetService;
